import React from "react";
import PropTypes from "prop-types";
import IconButton from "../IconButton";
import Plus from "~/static/images/icons/plus2.svg";
import Minus from "~/static/images/icons/minus2.svg";

const AddButton = (props) => {
    const getProps = () => {
        switch (props.buttonState) {
            case "add":
                return { icon: Plus };
            case "subtract":
                return { icon: Minus };
            case "remove":
                return {
                    icon: Plus,
                    iconProps: { style: { transform: "rotate(45deg)" } },
                };
        }
    };

    return (
        <IconButton
            {...props}
            {...getProps()}
            appearance={props.buttonState === "remove" ? "remove" : "default"}
        />
    );
};

AddButton.propTypes = {
    buttonState: PropTypes.string,
    rounded: PropTypes.bool,
};

export default AddButton;
